"use client";

import { ChatHistory } from "@/components/chat-history";
import { useDevices } from "@/components/device-provider";

export default function HistoryPage() {
  const { selected } = useDevices();
  // key: switching devices remounts the history, resetting pagination and
  // playback state wholesale instead of patching them one by one.
  return <ChatHistory key={selected.device_id} deviceId={selected.device_id} />;
}
